/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilteredQuery } from '../../models/filtered-query';
import { GetProjectLocationsQueryResult } from '../../models/get-project-locations-query-result';
import { SortedQuery } from '../../models/sorted-query';

export interface ApiProjectLocationsGetProjectLocationsGet$Plain$Params {
  ProjectId?: string;
  PageNumber?: number;
  PageSize?: number;
  Filters?: Array<FilteredQuery>;
  Sorts?: Array<SortedQuery>;
  SearchTerm?: string;
}

export function apiProjectLocationsGetProjectLocationsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectLocationsGetProjectLocationsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectLocationsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectLocationsGetProjectLocationsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('ProjectId', params.ProjectId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Filters', params.Filters, {});
    rb.query('Sorts', params.Sorts, {});
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectLocationsQueryResult>;
    })
  );
}

apiProjectLocationsGetProjectLocationsGet$Plain.PATH = '/api/ProjectLocations/GetProjectLocations';
